import React from 'react'
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import Navigation from './components/Navigation'
import Footer from './components/Footer'
import HomePage from './pages/HomePage'
import MetalRoofingPage from './pages/MetalRoofingPage'
import CommercialRoofingPage from './pages/CommercialRoofingPage'
import RepairMaintenancePage from './pages/RepairMaintenancePage'
import VirtualEstimatePage from './pages/VirtualEstimatePage'
import SavedEstimates from './components/SavedEstimates'
import BlogPage from './pages/BlogPage'
import BlogPostPage from './pages/BlogPostPage'
import BlogManagementPage from './pages/BlogManagementPage'

function App() {
  return (
    <Router>
      <div className="min-h-screen bg-gradient-to-b from-gray-50 to-gray-100 flex flex-col">
        <Navigation />
        <main className="flex-grow container mx-auto px-4 py-8">
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/metal-roofing" element={<MetalRoofingPage />} />
            <Route path="/commercial" element={<CommercialRoofingPage />} />
            <Route path="/repair" element={<RepairMaintenancePage />} />
            <Route path="/virtual-estimate" element={<VirtualEstimatePage />} />
            <Route path="/saved-estimates" element={<SavedEstimates />} />
            <Route path="/blog" element={<BlogPage />} />
            <Route path="/blog/:slug" element={<BlogPostPage />} />
            <Route path="/blog-management" element={<BlogManagementPage />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  )
}

export default App
